export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      aria-hidden="true"
    >
      <mask id="a" width="24" height="24" x="0" y="0">
        <path fill="#D9D9D9" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="currentColor"
          d="m8.228 16.837-1.064-1.064L10.937 12 7.164 8.252l1.064-1.064L12 10.961l3.748-3.773 1.063 1.064L13.04 12l3.773 3.773-1.063 1.064L12 13.063l-3.773 3.774Z"
        />
      </g>
    </svg>
  );
};
